$.fn.productPolicies = function() {
  let self = this
  self.content = $('#' + self.attr('data-content'))

  self.content.find('.product-policies__overlay, .product-policies__close').click(function() {
    self.content.removeClass('--open');
  })

  self.click(function() {
    self.content.addClass('--open');
  })

  return function() {
    return self
  }()
};
